import { render } from "./FormInputTag.vue?vue&type=template&id=a4d35e3e&scoped=true"
import script from "./FormInputTag.vue?vue&type=script&lang=js"
export * from "./FormInputTag.vue?vue&type=script&lang=js"

import "./FormInputTag.vue?vue&type=style&index=0&id=a4d35e3e&lang=scss&scoped=true"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4d35e3e"]])

export default __exports__